import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
// import { LoadingDialog } from "../../../../_metronic/_partials/controls/LoadingDialog";
import axios from "axios";
import AuthCard from "../../../components/Card/AuthCard";
import { i18n } from "../../../pages/private/languageSelector";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const VerifyAccount = ({ onHide }) => {
  let { token } = useParams();
  const { language } = useSelector((state) => state.auth);
  useEffect(() => {
    if (token) {
      axios
        .get(`api/confirm/${token}`)
        .then((res) => {
          // toast.success("Account verified");
          // history.push("/logout");
        })
        .catch((error) => {
          // toast.error("Error verifying account");
          // onHide();
        });
    }
    // eslint-disable-next-line
  }, [token]);
  return (
    <>
      {/* <div className="spinner spinner-lg spinner-success" /> */}
      {/* <LoadingDialog isLoading={true} text="Verifing your account ..." /> */}
      <div className="h-100 verify-account-wrapper">
        <div
          style={{
            minWidth: language === "arabic" && "355px",
            maxWidth: language === "english" && "355px",
            textAlign: language === "arabic" ? "right" : "left",
          }}
        >
          <AuthCard showLanguageSelector={false} selectedLanguage={language}>
            <span className="congratulation-text"> {i18n("ActivateAccount.Congratulations")}</span>
            <div className="mt-4 verify-account-text">
              <div>{i18n("ActivateAccount.YourRegNowConfirmed")}</div>
              <div className="pb-3">{i18n("ActivateAccount.YouMayProceedToBackOffice")}</div>
            </div>
          </AuthCard>
          <Link to={"/analytics/sales-summary"} className={`font-bold-600 mt-4 ${language === "arabic" ? "mr-2 text-right" : "ml-2 text-left"}`}>
            {i18n("ActivateAccount.EnterBackOffice")}
          </Link>
        </div>
      </div>
    </>
  );
};
export default VerifyAccount;
